import { Routes, Route } from 'react-router-dom';
import CheckoutPage from './pages/CheckoutPage';
import PayoutSimulatorPage from './pages/PayoutSimulatorPage';

/**
 * Main App Component
 * Handles routing for the checkout application
 */
function App() {
  return (
    <Routes>
      <Route path="/checkout/:token" element={<CheckoutPage />} />
      <Route path="/payout-simulator/:token" element={<PayoutSimulatorPage />} />
    </Routes>
  );
}

export default App;
